import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Rotas} from "src/app/core/rotas";
import {BaseService} from "../base/base.service";
import {ConsultaBanco} from "../../core/consulta-banco";

@Injectable({
    providedIn: "root",
})
export class TipoConteudoRimService extends BaseService<ConsultaBanco> {
    constructor(http: HttpClient) {
        super(http, Rotas.TIPO_CONTEUDO_RIM);
    }
}
